import { makeStyles, tokens } from '@coreai/fluentui-react';

export const useStyles = makeStyles({
  dialogSurface: {
    maxWidth: '640px',
    width: '100%',
    minHeight: '520px',
  },
  dialogBody: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: '480px',
  },
  dialogContent: {
    paddingTop: tokens.spacingVerticalM,
    flex: 1,
    overflowY: 'auto',
  },
  dialogActions: {
    paddingTop: tokens.spacingVerticalM,
    marginTop: 'auto',
    justifyContent: 'flex-end',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
    marginTop: tokens.spacingVerticalXXL,
  },
  infoBar: {
    marginBottom: tokens.spacingVerticalXS,
    '& .fui-MessageBarBody': {
      whiteSpace: 'normal',
      wordWrap: 'break-word',
    },
  },
  fieldRow: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: tokens.spacingHorizontalS,
  },
  fieldControl: {
    flex: 1,
    minWidth: 0,
  },
  refreshButton: {
    flexShrink: 0,
  },
  refreshButtonSpacer: {
    flexShrink: 0,
    width: '32px',
    height: '32px',
  },
  statusContainer: {
    marginTop: tokens.spacingVerticalM,
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
  },
  statusText: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
  errorContainer: {
    marginTop: tokens.spacingVerticalS,
  },
  errorText: {
    color: tokens.colorPaletteRedForeground1,
  },
});
